/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import HorizontalMenu from "components/HorizontalMenu";
import { HEIGHT_HEADER_HORIZONTAL_MENU } from "config/constant";

import { Grid, IconButton } from "@material-ui/core";
import { connect } from "react-redux";
import {
	getListNotificationAction,
	postWatchedNotificationAction,
	menuNotificationAction
} from "store/actions/NotificationPageAction";
import { getListCampaignAction } from "store/actions/SpecialOfferPageAction";
import { useHistory } from "react-router-dom";
import NotificationItem from "./Components/NotificationItem";

const HEIGHT_BODY = 50 + HEIGHT_HEADER_HORIZONTAL_MENU;

const NotificationPage = props => {
	const {
		getListNotification,
		notifications,
		postWatchedNotification,
		getListCampaign,
		listLoyalty,
		menuNotification,
		menuActive,
		infoShop
	} = props;

	const classes = useStyles();
	const [value, setValue] = useState(menuActive);
	const history = useHistory();

	const business = infoShop?.business || "THOPHAT";

	const handleChange = (event, newValue) => {
		setValue(newValue);
		menuNotification(newValue);
	};

	const MENU_NOTIFICATION = [
		{
			label: "Tất cả",
			code: "ALL",
			component: (
				<NotificationItem
					notifications={notifications}
					postWatchedNotification={postWatchedNotification}
					listLoyalty={listLoyalty}
				/>
			)
		},
		{
			label: "Chưa đọc",
			code: "CREATED",
			component: (
				<NotificationItem
					notifications={notifications}
					postWatchedNotification={postWatchedNotification}
					listLoyalty={listLoyalty}
				/>
			)
		},
		{
			label: "Đã đọc",
			code: "WATCHED",
			component: (
				<NotificationItem
					notifications={notifications}
					postWatchedNotification={postWatchedNotification}
					listLoyalty={listLoyalty}
				/>
			)
		}
	];

	useEffect(() => {
		getListCampaign(business);
		getListNotification(MENU_NOTIFICATION[menuActive]?.code);
	}, []);

	const handleHorizontalMenu = code => {
		getListNotification(code);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootHeader }}>
				<Grid classes={{ root: classes.titleHeader }}>Thông báo</Grid>
				<IconButton
					classes={{ root: classes.btnClose }}
					onClick={() => history.goBack()}
				>
					<CloseIcon />
				</IconButton>
			</Grid>

			<HorizontalMenu
				listMenu={MENU_NOTIFICATION}
				value={value}
				handleChange={handleChange}
				heightBody={`calc(100vh - ${HEIGHT_BODY}px)`}
				isMobile={false}
				handleHorizontalMenu={handleHorizontalMenu}
			/>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		notifications: state.notificationPageReducer.notifications,
		listLoyalty: state.specialOfferPageReducer.listLoyalty,
		menuActive: state.notificationPageReducer.menuActive,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getListNotification: data => {
			dispatch(getListNotificationAction(data));
		},
		postWatchedNotification: data => {
			dispatch(postWatchedNotificationAction(data));
		},
		getListCampaign: data => {
			dispatch(getListCampaignAction(data));
		},
		menuNotification: data => {
			dispatch(menuNotificationAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPage);
